import useSWR, { SWRResponse } from "swr";
import commonSwrConfig from "../commonSwrConfig";
import { ICustomerAgreement } from "@portal/types/api/ICustomerAgreement";
import { IUseCustomerAgreementsForLoggedInCustomer } from "./types";
import { useSession } from "@portal/auth/client/SessionProvider";
import { useMemo } from "react";
//import useAdvisor from "../useAdvisor";
import { IUpdatedTermsConfirmation } from "@portal/types/api/IUpdatedTermsConfirmation";
import { commonFetcher } from "../common/commonFetcher";

// TODO: Uncomment this when updated terms are available
//const LAST_UPDATED_CUSTOMER_AGREEMENT = "2024-05-10";

const useCustomerAgreementsForLoggedInCustomer: IUseCustomerAgreementsForLoggedInCustomer = () => {
  const { update } = useSession();
  //const { isAdvisor } = useAdvisor();

  const confirmUpdatedAgreement = async (): Promise<void> => {
    const response = await fetch(`/api/customerInfo/updated-terms-confirmations`, {
      method: "POST",
      headers: [["accepts", "application/json"]],
    });

    if (response.status !== 200) {
      throw response.status;
    }
  };

  // TODO: Uncomment this when updated terms are available
  const {
    //data: terms,
    isLoading: termsIsLoading,
    //error: termsError,
    mutate: mutateTerms,
  }: SWRResponse<IUpdatedTermsConfirmation[], unknown> = useSWR(
    `/api/customerInfo/updated-terms-confirmations`,
    commonFetcher<IUpdatedTermsConfirmation[]>,
    commonSwrConfig(update),
  );

  const { data, isLoading, error }: SWRResponse<ICustomerAgreement[], unknown> = useSWR(
    `/api/customerInfo/customer-agreements-for-logged-in-customer`,
    commonFetcher<ICustomerAgreement[]>,
    commonSwrConfig(update),
  );

  // TODO: Uncomment this when updated terms are available
  // const lastAgreedTerms = useMemo(() => {
  //   const lastAgreedTerms = terms?.reduce((acc: IUpdatedTermsConfirmation | undefined, curr: IUpdatedTermsConfirmation) => {
  //     if (acc === undefined) return curr;
  //     if (new Date(curr.confirmationDate) > new Date(acc.confirmationDate)) return curr;
  //     return acc;
  //   }, undefined);

  //   return lastAgreedTerms;
  // }, [terms]);

  const lastUpdatedAgreement = useMemo(() => {
    const lastUpdatedAgreement = data?.reduce((acc: ICustomerAgreement | undefined, curr: ICustomerAgreement) => {
      if (acc === undefined) return curr;
      if (new Date(curr.createdDate) > new Date(acc.createdDate)) return curr;
      return acc;
    }, undefined);

    return lastUpdatedAgreement;
  }, [data]);

  const isAgreementOutOfDate = false;
  // TODO: Uncomment this when updated terms are available
  // useMemo(() => {
  //   return (
  //     !isAdvisor &&
  //     !error &&
  //     !termsError &&
  //     (lastAgreedTerms === undefined || new Date(lastAgreedTerms.confirmationDate) < new Date(LAST_UPDATED_CUSTOMER_AGREEMENT)) &&
  //     (lastUpdatedAgreement === undefined ||
  //       new Date(lastUpdatedAgreement.createdDate) < new Date(LAST_UPDATED_CUSTOMER_AGREEMENT))
  //   );
  // }, [lastUpdatedAgreement, lastAgreedTerms, termsError, error, isAdvisor]);

  return {
    confirmUpdatedAgreement,
    isAgreementOutOfDate,
    lastUpdatedAgreement,
    error,
    isLoading: isLoading || termsIsLoading,
    mutateTerms,
  };
};

export default useCustomerAgreementsForLoggedInCustomer;
